module.exports = __webpack_public_path__ + "static/bf-newsletter-cb47e0c1d149024e60348d04d329ef5f.jpg";